import React from "react";

interface ErrorBannerProps {
  message: string | null | undefined;
  className?: string;
}

export function ErrorBanner({ message, className }: ErrorBannerProps) {
  if (!message) {
    return null;
  }
  return (
    <div
      className={[
        "border-2 border-accent bg-canvas px-4 py-3 font-mono text-xs uppercase tracking-wider text-accent",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {message}
    </div>
  );
}
